// One mechanism for "may this response still be committed?".
//
// THE PROPERTY
//   A response may only be committed into a view if it still belongs to the newest request of its
//   kind. An out-of-order response commits nothing — not the items, not the terminal snackbar.
//
// WHY THIS EXISTS
//   The same defect was reported three times on three different surfaces: the booking import
//   (twice) and the SMS Logs search. Each had been fixed in place, which is why it kept coming
//   back somewhere else. Every action that sends operator-controlled parameters and commits the
//   response now goes through this, and `tests/wiring.test.mjs` fails if a new one does not.
//
// WHY A CLOSURE AND NOT A SHARED REGISTRY
//   Each call site owns its own counter, so two unrelated screens can never supersede each other,
//   and there is no key to spell wrong. `begin()` hands back the predicate for the token it just
//   allocated — you cannot hold a token and test a different one.
//
// WHY MODULE SCOPE IS SAFE HERE
//   The counter lives outside the Vuex store, which was a real problem for the import guard (a
//   module-level BOOLEAN could latch shut and no test could see it). A monotonic counter cannot
//   latch: its only failure on reload is starting from zero again, which is exactly the isolation
//   a fresh page — or a fresh test — should get.
export function createLatestOnly() {
  let latest = 0
  return function begin() {
    const token = ++latest
    return () => token === latest
  }
}
